export default __webpack_public_path__ + "static/media/knifefun.a8fa8d00.jpg";